import { useState } from 'react';
import { useDialog } from '@mews/framework';
import { Stack, Button, IconName } from '@optimus-web/core';
import { ExportType } from '../../constants';
import { CityLedgerExportDialog } from './CityLedgerExportDialog';

const renderDialog = (exportType: ExportType, handleExportDialogClose: () => void) => {
    switch (exportType) {
        case ExportType.EXPORT:
            return <CityLedgerExportDialog type={ExportType.EXPORT} onClose={handleExportDialogClose} />;
        case ExportType.PRINT:
        case ExportType.RECURRING:
        default:
            return null;
    }
};

export const ExportMenu = () => {
    const [view, setView] = useState<ExportType>(ExportType.EXPORT);

    const [{ active: isExportDialogOpen, onClose: handleExportDialogClose }, toggleExportDialogOpen] = useDialog();

    return (
        <Stack data-test-id="actions-menu">
            <Button
                data-test-id="report-export-menu"
                icon={IconName.Exports}
                type="button"
                size="small"
                variant="tertiary"
                onClick={() => {
                    setView(ExportType.EXPORT);
                    toggleExportDialogOpen();
                }}
            />
            {isExportDialogOpen ? renderDialog(view, handleExportDialogClose) : null}
        </Stack>
    );
};
